import React from "react";
import { PublicNoticesUIProvider } from "./PublicNoticesUIContext";
import { PublicNoticesCard } from "./PublicNoticesCard";

export function PublicNoticesPage({ history }) {
  const publicNoticesUIEvents = {
    openNewPublicNoticePage: () => {
      history.push("/genel-duyurular/ekle");
    },
    openPublicNoticeDetailPage: (id) => {
      history.push(`/genel-duyurular/detay/${id}`);
    },
  };
  
  return (
    <PublicNoticesUIProvider publicNoticesUIEvents={publicNoticesUIEvents}>
      <PublicNoticesCard />
    </PublicNoticesUIProvider>
 );
}